// FILE: src/app/(auth)/error.tsx
// VERSION: 1.0.0
// START_MODULE_CONTRACT:
// PURPOSE: Глобальный Error Boundary для страниц аутентификации (login, register, reset-password, update-password).
// SCOPE: (auth) — центрированная светлая/нейтральная тема
// INPUT: Error объект из Next.js Error Boundary
// OUTPUT: UI с предложением повторить попытку
// KEYWORDS: DOMAIN(ErrorBoundary); CONCEPT(Auth, ErrorHandling)
// LINKS: USES_API(Next.js ErrorBoundary); USES_API(lucide-react AlertTriangle)
// END_MODULE_CONTRACT

'use client';

import { useEffect } from 'react';
import { Button } from '@oxpa/shared/ui/button';
import { AlertTriangle } from 'lucide-react';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error('[Auth Error]', error);
  }, [error]);

  return (
    <div className="flex items-center justify-center min-h-screen p-8">
      <div className="flex flex-col items-center gap-4 max-w-md text-center">
        <div className="rounded-full bg-destructive/10 p-4">
          <AlertTriangle className="w-8 h-8 text-destructive" />
        </div>
        <h2 className="text-xl font-bold">Что-то пошло не так</h2>
        <p className="text-muted-foreground text-sm">
          Произошла ошибка при загрузке страницы. Попробуйте обновить страницу.
        </p>
        <Button onClick={() => reset()} variant="default">
          Попробовать снова
        </Button>
      </div>
    </div>
  );
}
